(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.menuToggle = document.getElementById('menu-open');
      this.mainNav = document.getElementById('navigation');

      if (this.menuToggle) {
        this.menuToggle.addEventListener('click', e => this.toggleNav(e));
      }
      this.handleEscapeKey = this.onEscapeKey.bind(this);
      document.addEventListener('keydown', this.handleEscapeKey);

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      document.querySelectorAll('.menu-switch').forEach((menuSwitch) => menuSwitch.addEventListener('click', (e) => {
        this.displaySubMenu(e);
      }));

      document.querySelectorAll('.submenu-back').forEach((submenuBack) => submenuBack.addEventListener('click', (e) => {
        this.closeSubMenu(e);
      }));

      // Handle focus leaving the navigation drawer
      if (this.mainNav) {
        this.handleFocusOut = this.onFocusOut.bind(this);
        this.mainNav.addEventListener('focusout', this.handleFocusOut);
      }

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.handleEscapeKey) {
        document.removeEventListener('keydown', this.handleEscapeKey);
      }
      if (this.mainNav && this.handleFocusOut) {
        this.mainNav.removeEventListener('focusout', this.handleFocusOut);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }

    closeNav(returnFocus = true) {
      if (!this.mainNav || !this.menuToggle) return;
      
      this.menuToggle.setAttribute('aria-expanded', 'false');
      this.menuToggle.id = 'menu-open';
      this.menuToggle.setAttribute('aria-label', 'Menu');
      this.menuToggle.textContent = 'Menu';
      this.mainNav.style['display'] = 'none';
      this.mainNav.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('znt--mobile-menu-open');
      
      // Remove any active focus traps
      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus();
      }
      
      // Clear active submenu references
      this.activeSubmenu = null;
      this.activeMenuSwitch = null;
      
      // Return focus to button only if requested (not when focus is leaving naturally)
      if (returnFocus) {
        setTimeout(() => {
          if (this.menuToggle) {
            this.menuToggle.focus();
          }
        }, 300);
      }
    }

    openNav() {
      if (!this.mainNav || !this.menuToggle) return;
      
      this.menuToggle.setAttribute('aria-expanded', 'true');
      this.menuToggle.id = 'menu-close';
      this.menuToggle.setAttribute('aria-label', 'Close');
      this.menuToggle.textContent = 'Close';
      this.mainNav.style['display'] = 'flex';
      this.mainNav.setAttribute('aria-hidden', 'false');
      document.body.classList.add('znt--mobile-menu-open');
    }

    toggleNav(e) {
      e.preventDefault();
      const isExpanded = this.menuToggle.getAttribute('aria-expanded') === 'true';
      
      if (isExpanded) {
        this.closeNav();
      } else {
        this.openNav();
      }
    }

    onEscapeKey(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        // Check if a submenu is open
        if (this.activeSubmenu) {
          const submenuBackButton = this.activeSubmenu.querySelector('.submenu-back a');
          if (submenuBackButton) {
            submenuBackButton.click();
          }
          return;
        }
        
        const isExpanded = this.menuToggle && this.menuToggle.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          this.closeNav();
        }
      }
    }

    onFocusOut(e) {
      // Use setTimeout to check where focus actually went
      // This is necessary because focusout fires before the new element receives focus
      setTimeout(() => {
        const isExpanded = this.menuToggle && this.menuToggle.getAttribute('aria-expanded') === 'true';
        if (!isExpanded || !this.mainNav) return;
        
        // Check if focus is now outside the navigation drawer
        const activeElement = document.activeElement;
        const isFocusInsideNav = this.mainNav.contains(activeElement) || activeElement === this.menuToggle;
        
        // If focus has left the navigation drawer, close it
        // Don't return focus - let it continue naturally to the next element
        if (!isFocusInsideNav) {
          this.closeNav(false);
        }
      }, 0);
    }

    displaySubMenu(event) {
      event.preventDefault();
      
      const subMenuItem = document.getElementById(event.target.getAttribute('submenu-name'));
      const closeBtn = document.querySelectorAll('.mega-menu__submenu-back');
      
      // Store reference to the menu-switch button that opened this submenu for focus return
      this.activeMenuSwitch = event.target;
      // Store reference to the active submenu for Escape key handling
      this.activeSubmenu = subMenuItem;
      
      document.querySelectorAll('.submenu').forEach((submenu) => submenu.classList.replace('d-flex', 'd-none'));
      document.querySelectorAll('.submenu-back').forEach((submenuBack) => submenuBack.addEventListener('click', (e) => {
        this.closeSubMenu(e);
      }));
      subMenuItem.classList.replace('d-none', 'd-flex');
      if (window.matchMedia('(min-width: 990px)').matches) {
        closeBtn.forEach((close) => close.classList.replace('d-none', 'd-block'));
      }
      subMenuItem.setAttribute('aria-hidden', 'false');
      
      // Find the submenu-back button within this submenu and focus it
      const submenuBackButton = subMenuItem.querySelector('.submenu-back a');
      if (submenuBackButton) {
        // Use setTimeout to ensure the submenu is fully visible before focusing
        setTimeout(() => {
          submenuBackButton.focus();
          // Trap focus within the submenu (only on mobile)
          if (typeof trapFocus === 'function' && window.matchMedia('(max-width: 989px)').matches) {
            trapFocus(subMenuItem, submenuBackButton);
          }
        }, 0);
      }
    }

    closeSubMenu(event) {
      event.preventDefault();

      const subMenuItem = document.getElementById(event.target.getAttribute('submenu-name'));
      const closeBtn = document.querySelectorAll('.mega-menu__submenu-back');

      // Remove focus trap
      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus();
      }

      // Clear active submenu reference
      this.activeSubmenu = null;

      if (window.matchMedia('(min-width: 990px)').matches) {
        closeBtn.forEach((close) => close.classList.replace('d-block', 'd-none'));
      }
      Array.from(document.getElementsByClassName('submenu')).forEach(element => {
          element.classList.replace('d-flex', 'd-none');
          subMenuItem.setAttribute('aria-hidden', 'true');
      });
      
      // Return focus to the menu-switch button that opened this submenu
      if (this.activeMenuSwitch) {
        setTimeout(() => {
          this.activeMenuSwitch.focus();
          this.activeMenuSwitch = null;
        }, 0);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
